import React from "react";

function MojafinLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="13.4"
      version="1.1"
      viewBox="0 0 132.292 14.817"
    >
      <g>
        <g
          stroke="none"
          strokeWidth="0.265"
          transform="matrix(.23539 0 0 .23539 .836 -36.258)"
        >
          <path
            fill="#266285"
            d="M47.36 186.07c-3.09 3.087-6.11 6.113-9.14 9.13-2.601 2.589-5.566 2.627-8.137.068-9.997-9.95-19.977-19.915-29.976-29.863-1.623-1.615-2.195-3.502-1.5-5.669.647-2.02 2.136-3.203 4.212-3.563 1.853-.321 3.34.448 4.627 1.73 6.09 6.066 12.195 12.115 18.275 18.19 2.772 2.77 5.499 5.585 8.36 8.496 3.828-3.859 7.507-7.586 11.206-11.293a8728.69 8728.69 0 0115.43-15.42c1.555-1.553 3.395-2.23 5.542-1.495 2.047.7 3.283 2.18 3.59 4.337.263 1.842-.461 3.341-1.753 4.63-6.896 6.879-13.78 13.77-20.736 20.721z"
            opacity="1"
          ></path>
          <path
            fill="#256185"
            d="M556.237 207.41c.813.816 1.57 1.555 2.307 2.314 2.295 2.363 2.38 5.479.22 7.665-2.128 2.154-5.355 2.09-7.668-.22-11.198-11.185-22.381-22.385-33.57-33.58-6.107-6.111-12.21-12.23-18.326-18.333-1.55-1.545-2.076-3.364-1.447-5.44.634-2.094 2.146-3.31 4.278-3.65 1.833-.292 3.351.445 4.639 1.732 9.294 9.286 18.591 18.568 27.887 27.852 7.206 7.197 14.41 14.395 21.68 21.66z"
            opacity="1"
          ></path>
          <path
            fill="#266185"
            d="M303.298 168.796c-1.022-1.858-2.157-3.563-2.939-5.418-1.387-3.292.605-6.652 4.114-7.23 2.112-.348 4.046.635 5.26 2.73 3.287 5.677 6.56 11.363 9.837 17.046 6.709 11.632 13.427 23.258 20.118 34.9 1.988 3.46.106 7.503-3.763 8.048-2.489.35-4.218-.938-5.43-2.986-1.658-2.804-3.27-5.636-4.899-8.458-7.417-12.848-14.834-25.698-22.298-38.632z"
            opacity="1"
          ></path>
          <path
            fill="#266285"
            d="M116.579 160.047c1.22-.517 2.314-1.14 3.491-1.432 2.462-.611 4.92.762 5.897 3.117a5.104 5.104 0 01-2.068 6.34c-1.199.737-2.511 1.298-3.67 2.088-13.545 9.234-12.092 29.04 2.641 36.244 3.309 1.617 4.484 4.737 2.859 7.59-1.368 2.4-4.251 3.366-6.871 2.122-10.118-4.804-16.353-12.718-18.075-23.788-2.065-13.278 4.088-25.56 15.796-32.281z"
            opacity="1"
          ></path>
          <path
            fill="#266185"
            d="M157.985 204.89c-3.436 5.042-7.84 8.8-13.327 11.258-2.485 1.113-5.207.325-6.654-1.858-1.418-2.14-1.093-5.04.828-6.74.55-.485 1.24-.828 1.903-1.165 7.64-3.876 11.848-10.09 11.95-18.645.105-8.704-4.186-14.983-11.82-19.003-2.876-1.514-4.216-3.804-3.513-6.329.934-3.36 4.362-4.842 7.706-3.278 5.445 2.546 9.922 6.29 13.076 11.4 7.04 11.406 6.905 22.874-.149 34.36z"
            opacity="1"
          ></path>
          <path
            fill="#256185"
            d="M292.757 205.82c-2.16 0-4.189.043-6.214-.023-.86-.028-1.34.227-1.762 1a353.739 353.739 0 01-5.068 8.973c-1.43 2.45-3.542 3.53-5.76 3.057-3.686-.786-5.445-4.59-3.568-7.893 3.742-6.587 7.543-13.14 11.32-19.706 2.043-3.55 4.075-7.108 6.136-10.648 1.512-2.597 4.465-3.502 7.034-2.196 2.546 1.294 3.643 4.156 2.298 6.857-1.47 2.95-3.256 5.742-4.901 8.606-.234.408-.448.828-.775 1.437.653.031 1.11.072 1.569.073 3.041.006 6.083-.013 9.124.01 3.255.023 5.525 2.237 5.494 5.316-.03 2.977-2.317 5.114-5.538 5.134-3.085.019-6.17.004-9.389.004z"
            opacity="1"
          ></path>
          <path
            fill="#276286"
            d="M370.089 167.942c0-2.248-.043-4.364.014-6.478.075-2.842 2.004-4.978 4.727-5.342 2.372-.316 4.846 1.318 5.557 3.74.182.62.22 1.3.221 1.953.011 17.143.013 34.286.005 51.428-.003 3.32-2.25 5.726-5.278 5.708-2.992-.018-5.238-2.464-5.24-5.795-.013-15.027-.006-30.054-.006-45.214z"
            opacity="1"
          ></path>
          <path
            fill="#276285"
            d="M453.883 205.777c0-14.719-.003-29.305 0-43.891 0-2.712 1.2-4.613 3.39-5.43a5.217 5.217 0 016.976 3.896 8.2 8.2 0 01.149 1.572c.008 17.055.008 34.109.004 51.163 0 2.699-1.194 4.614-3.37 5.464a5.194 5.194 0 01-7.13-4.71c-.08-2.642-.018-5.287-.02-8.064z"
            opacity="1"
          ></path>
          <path
            fill="#266285"
            d="M239.829 201.271c-1.847 5.708-5.177 10.184-10.078 13.467-2.567 1.72-5.654 1.187-7.35-1.224-1.713-2.431-1.222-5.516 1.38-7.312 4.69-3.239 6.701-7.631 6.624-13.303-.14-10.358-.045-20.72-.036-31.08.003-2.786 1.455-4.836 3.85-5.512 3.374-.952 6.63 1.537 6.654 5.16.036 5.775.012 11.55.012 17.325 0 5.07.106 10.143-.048 15.208-.072 2.397-.64 4.78-1.008 7.271z"
            opacity="1"
          ></path>
          <path
            fill="#276286"
            d="M-1.302 215.61c-.152-.7-.354-1.303-.355-1.906-.02-7.314-.036-14.628.006-21.941.015-2.675 2.07-4.846 4.633-5.082 2.74-.253 5.105 1.396 5.713 4.024.117.507.126 1.047.126 1.571.008 6.961.006 13.923.003 20.884 0 2.949-1.455 4.97-4.022 5.604-2.504.619-4.69-.484-6.104-3.155z"
            opacity="1"
          ></path>
          <path
            fill="#276286"
            d="M413.143 156.089c1.982 0 3.832-.021 5.682.008 3.118.048 5.426 2.32 5.418 5.298-.007 2.921-2.277 5.19-5.339 5.203-7.224.033-14.448.033-21.672 0-3.069-.014-5.278-2.275-5.268-5.255.01-2.934 2.273-5.217 5.32-5.24 5.243-.041 10.485-.013 15.859-.014z"
            opacity="1"
          ></path>
          <path
            fill="#276285"
            d="M59.402 200.221c0-2.818-.022-5.503.007-8.189.034-3.119 2.19-5.34 5.152-5.362 3.055-.023 5.33 2.16 5.35 5.322.047 7.22.05 14.44-.002 21.66-.022 2.983-2.472 5.335-5.309 5.297-2.895-.039-5.164-2.354-5.188-5.389-.035-4.402-.01-8.804-.01-13.339z"
            opacity="1"
          ></path>
          <path
            fill="#256185"
            d="M507.986 198.104c-.005 5.335.022 10.538-.03 15.74-.022 2.272-1.545 4.188-3.644 4.837-2.149.663-4.464-.007-5.734-1.899-.56-.832-.995-1.935-1.006-2.92-.083-7.406-.082-14.813-.028-22.22.02-2.824 2.315-4.954 5.125-4.976 2.91-.023 5.182 2.061 5.288 4.958.077 2.113.024 4.232.03 6.48z"
            opacity="1"
          ></path>
          <path
            fill="#256185"
            d="M549.814 169c.01-2.689-.06-5.249.048-7.801.118-2.742 2.031-4.722 4.683-5.073 2.29-.302 4.672 1.198 5.466 3.505.196.57.289 1.205.29 1.81.02 7.23.035 14.46 0 21.69-.012 2.691-1.908 4.879-4.351 5.194-2.723.352-5.157-1.114-5.863-3.617-.211-.75-.254-1.565-.258-2.35-.025-4.409-.014-8.817-.016-13.358z"
            opacity="1"
          ></path>
          <path
            fill="#276285"
            d="M191.186 193.225c.89-3.186 3.166-4.77 6.079-4.341 2.59.381 4.338 2.624 4.385 5.607.08 5.017 2.351 8.808 6.433 11.632 3.079 2.13 3.35 5.986.653 8.356-1.757 1.542-4.248 1.785-6.237.42-7.552-5.187-11.498-12.298-11.313-21.674z"
            opacity="1"
          ></path>
          <path
            fill="#276286"
            d="M415.35 186.182c.617 3.852-1.613 6.563-5.365 6.59-4.186.03-8.373.029-12.56-.002-3.193-.023-5.457-2.221-5.458-5.223-.003-3.09 2.25-5.263 5.533-5.28 4.142-.02 8.285-.013 12.427-.002 2.736.008 4.446 1.228 5.423 3.917z"
            opacity="1"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default MojafinLogo;